import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="hero">
      <div className="hero-background">
        <div className="hero-container">
          <div className="hero-left">
            <div className="hero-info">
              <span className="hero-label">Moscow, Russia</span>
              <div className="hero-collection">
                <span>Exotic car collection</span>
                <span>by CNCCAR</span>
              </div>
            </div>

            <div className="hero-description">
              <p>
                From exotic sports cars to luxury sedans and SUVs, CNCCAR's Exotic Car Collection offers an exceptional selection and CNCCAR's trusted, personalised service.
              </p>
            </div>
          </div>
          
          <div className="hero-right">
            <h1 className="hero-title">
              <span className="title-line">Buy the luxury</span>
              <span className="title-line">Own the thrill.</span>
            </h1>
          </div>
          
          <div className="hero-actions">
            <a href="#buy" className="action-btn">
              Buy a car
              <span className="action-icon">→</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 